/**
 * Tuner feature flags for enrollment-client
 *
 * These flags are managed server-side via Tuner and can be toggled
 * without deploying code changes.
 */
export const tunerFlags = {
  disableNudataEnrollment: 'disable-nudata-enrollment',
};
